<script>
import { IonPage } from '@ionic/vue'

export default IonPage
</script>
